

const Voucher = ({ data }) => {

    const guest = data.Table?.[0] || {};
    const room = data.Table1?.[0] || {};
    const hotel = data.Table3?.[0] || {};

    return (
        <div id="voucher-content" className="p-4">
            {/* Page 1: Booking Details*/}
            {/* Header */}
            <div className="voucher-header d-flex justify-content-between align-items-center">
                <div>
                    <h4 className="voucher-title">Hotel Confirmation Voucher</h4>
                    <p className="booking-id">Booking ID - </p>
                    <p className="booking-date">Booking Date - {guest.BookingDate}</p>
                </div>
                <div>

                    <img
                        src={hotel.PropertyLogo || "N/A"}
                        alt="Property Logo"
                        style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            backgroundColor: "#f0f0f0",
                            border: "1px solid #ccc"
                        }}
                    />

                </div>
            </div>

            {/* Greeting */}
            <p className="greeting">
                Dear {guest.Title} {guest.FirstName} {guest.LastName},
            </p>

            <div className="text-center text-success fw-bold fs-5"><i className="fas fa-check-circle me-2"></i>Your Booking is Confirmed </div>

            {/* Note */}
            <p className="voucher-note ">
                Thank you for Booking at <strong>{hotel.DisplayName}</strong><br />
                kindly note, booking is <strong className="text-success">CONFIRMED</strong> and you are not required to contact the hotel or BookOnNile to reconfirm the same.<br />

                <b className="fw-bold">We hope you have a pleasent stay and look forword to assisting you again!</b><br />

            </p>


            {/* Hotel Details */}
            {/* <h6 className="section-title">Hotel Details</h6> */}
            <div className="row section-content">
                <div className="col-md-8">
                    <p> <strong>{hotel.DisplayName}</strong></p>
                    <p>Address: {hotel.Address}</p>
                    <p>Contact:  {hotel.HotelPhone}</p>
                    <p>Email: {hotel.EmailList}</p>
                    <p>Website : {hotel.WebsiteList}</p>
                </div>
            </div>


            <table className="table custom-table">
                <thead >
                    <tr>
                        <th style={{ width: "14  rem" }}>Room Type</th>
                        <th >Meal Plan</th>
                        <th style={{ width: "10rem" }}>Check-In</th>
                        <th style={{ width: '10rem' }}>Check-Out</th>
                        <th style={{ width: "5rem" }}>#Nights</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{room.RoomName}</td>
                        <td>{room.MeelPlan}</td>
                        <td>{room.CheckInDate}</td>
                        <td>{room.CheckOutDate}</td>
                        <td>{room.Nights}</td>
                    </tr>

                </tbody>
            </table>

            <table className="table custom-table">
                <thead>
                    <tr>
                        <th scope="col">Travelers</th>
                        <th scope="col">Daily Rate</th>
                        <th scope="col">Extra Charges</th>
                        <th scope="col">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{room.Travellers}</td>
                        <td>₹{room.RoomRate || 0}</td>
                        <td>₹{room.ExtraBedAmount || 0}</td>
                        <td>₹{room.Total || 0}</td>
                    </tr>
                </tbody>
            </table>

            <div>
                <p className="fw-bold text-end">Accommodation changes collected on behalf of Hotel(incl.application hotel taxes)</p>
            </div>

            <div className="card mt-5">
                <div className="card-body">
                    <div className="row mb-2">
                        <div className="col-md-6"> Service fees</div>
                        <div className="col-md-6 text-end">₹0</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-6">HR-SGST @ 9%</div>
                        <div className="col-md-6 text-end">₹0</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-6">CGST @ 9%</div>
                        <div className="col-md-6 text-end">₹0</div>
                    </div>
                    <div className="row mb-2 text-danger fw-bold">
                        <div className="col-md-6">Reversal of BookOnNile service fee</div>
                        <div className="col-md-6 text-end">- ₹0</div>
                    </div>
                    <div className="row mb-2 text-danger fw-bold">
                        <div className="col-md-6">Effective discount</div>
                        <div className="col-md-6 text-end">- ₹0</div>
                    </div>
                    <hr />
                    <div className="row fw-bold fs-5">
                        <div className="col-md-6">Grand Total:</div>
                        <div className="col-md-6 text-end">₹</div>
                    </div>
                </div>
            </div>

            {/* Tax invoice note */}
            <p className="mt-3">
                <strong>Note:</strong> Tax invoice for hotel accommodation charges would be issued by the hotel at the time of check-out.
            </p>

            <div className="page-break"></div>

            {/* Page 2*/}
            <div className="mt-5">
                <h2 className="mb-4 mt-5"><strong>Terms & Conditions</strong></h2>

                <div className="mb-4">
                    <h5 className="mb-2"><strong>• Arrival & Departure Policy:</strong></h5>
                    <ul>
                        <li>- <strong>Check-in:</strong> 1400 Hrs</li>
                        <li>- <strong>Check-out:</strong> 1200 Noon</li>
                        <li>
                            - <strong>Early Check-in:</strong> Subject to availability after 11:00 AM.
                            <ul>
                                <li>- Check-in between 06:00 AM to 09:00 AM: <strong>50% room charge</strong></li>
                                <li>- Check-in before 06:00 AM: <strong>Full one-day room charge</strong></li>
                                <li>- For guaranteed early check-in, full advance payment is required.</li>
                            </ul>
                        </li>
                        <li>
                            - <strong>Late Check-out:</strong> Subject to availability up to 15:00 Hrs.
                            <ul>
                                <li>- Check-out until 18:00: <strong>50% room charge</strong></li>
                                <li>- Check-out after 18:00: <strong>One-night charge at contracted rate</strong></li>
                            </ul>
                        </li>
                        <li>- Reservations without confirmed arrival time and guaranteed payment will be released after 1800 Hrs.</li>
                    </ul>
                </div>

                <div className="mb-4">
                    <h5 className="mb-2"><strong>• Cancellation Policy:</strong></h5>
                    <ul>
                        <li>- Cancellations must be made at least <strong>48 hours</strong> prior to arrival.</li>
                        <li>- Failure to cancel on time or no-show will attract <strong>one-day retention charges</strong>.</li>
                    </ul>
                </div>

                <div className="mb-4">
                    <h5 className="mb-2"><strong>• Guarantee Policy:</strong></h5>
                    <ul>
                        <li>- All bookings must be guaranteed via <strong>advance payment (UPI, credit card, or cash)</strong>.</li>
                    </ul>
                </div>

                <div className="mb-4">
                    <h5 className="mb-2"><strong>• Photo Identity:</strong></h5>
                    <ul>
                        <li>- All guests must present a valid <strong>Government-approved photo ID</strong> (Aadhar Card, Driving License, Voter ID, or Passport). <strong>PAN card is not accepted.</strong></li>
                        <li>- <strong>Foreign Nationals</strong> must present a valid Passport and Visa at check-in.</li>
                        <li>- <strong>Local ID guests and unmarried couples</strong> are not allowed as per hotel policy.</li>
                    </ul>
                </div>

                <div className="mb-4">
                    <h5 className="mb-2"><strong>• Additional Information:</strong></h5>
                    <ul>
                        <li>- Room tariff is applicable <strong>per room per night</strong>. Taxes and service charges are extra.</li>
                        <li>- <strong>Transfers</strong> are not included in the room tariff but can be arranged upon request on a chargeable basis.</li>
                        <li>- <strong>All bills</strong> must be settled directly at check-out. <strong>Personal cheques are not accepted.</strong></li>
                        <li>- <strong>Signing facility</strong> is only available to approved corporate accounts.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Voucher;
